// checkout product button
// (function () {
//     const buyNowButton = document.getElementById('add-to-cart-and-checkout')
//     if (buyNowButton) {
//         buyNowButton.addEventListener('click', function() {
//             var productId = buyNowButton.dataset.id;
//             var quantity = document.querySelector('.product-form__quantity .quantity__input').value;
        
//             // Clear the cart first
//             fetch('/cart/clear.js', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 }
//             })
//             .then(response => {
//                 if (!response.ok) {
//                     throw new Error('Failed to clear cart');
//                 }
//                 // Add the item after clearing
//                 return fetch('/cart/add.js', {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         items: [{
//                             id: productId,
//                             quantity: quantity
//                         }]
//                     })
//                 });
//             })
//             .then(response => {
//                 if (response.ok) {
//                     window.location.href = '/checkout';
//                 } else {
//                     console.error('Error adding item');
//                 }
//             })
//             .catch(error => {
//                 console.error('Error:', error);
//             });
//         });
//     }
// })();
// checkout product button

// add save price in ymq table
// (function () {
//     window.addEventListener("load", function() {
//         if (document.querySelector('.ymq-b2b-table')) {
//             const basePrice = parseFloat(document.querySelector('.ymq-b2b-current-product-price-parent-dom .ymq-b2b-price-span').getAttribute('data-ymq-money'));

//             document.querySelectorAll('.ymq-b2b-table-tr').forEach(row => {
//                 const quantity = parseInt(row.getAttribute('ymq-b2b-table-min'));
//                 const priceSpan = row.querySelector('.ymq-b2b-price-span');
//                 const discountedPrice = parseFloat(priceSpan.getAttribute('data-ymq-money'));
//                 const totalDiscount = (basePrice - discountedPrice) * quantity;
                
//                 const discountText = document.createElement('div');
//                 discountText.style.color = '#00fd13';
//                 if (document.querySelector('html').getAttribute('lang') == 'fr') {
//                     discountText.textContent = ` (Écon. $${totalDiscount.toFixed(2)}/cmd)`;
//                 } else {
//                     discountText.textContent = ` (Save $${totalDiscount.toFixed(2)} per order)`;
//                 }
                
    
//                 priceSpan.parentElement.appendChild(discountText);
//             });
//         }
//     });
// })();
// add save price in ymq table

// translate buy it now
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    var buyNowButtons = document.querySelectorAll('.shopify-payment-button__button');

    buyNowButtons.forEach(function(button) {
        if (button && button.textContent.includes('Buy it now')) {
            button.textContent = 'Купити зараз';
        }
    })
    
    
  });
})();
// translate buy it now